import React from "react";
import TimeDisplay from './TimeDisplay';

const WorkoutScreen = ({ phase, exercise, nextExercise, seconds, secondsUntilNext }) => {
  return (
    <div className="large-width">
      <h2>
        {phase}
      </h2>

      <TimeDisplay
        totalSeconds={seconds}
      />

      <br/>

      <div className="combo__wrapper">
        <div class="combo__item combo__item--current" dangerouslySetInnerHTML={{ __html: exercise }} />
        {nextExercise &&
          <div class="combo__item combo__item--next" dangerouslySetInnerHTML={{ __html: nextExercise }} />
        }
      </div>

      {(exercise || nextExercise) &&
        <p className={`time-display-next ${(secondsUntilNext > 5) ? 'time-display-next--hidden' : ''}`}>
          {secondsUntilNext}
        </p>
      }
    </div>
  )
}

export default WorkoutScreen;
